export default class BasketProductQuantity {
	constructor(productId, quantity) {
		this.productId = Number(productId)
		this.quantity = Number(quantity)
	}
}
